/**
 * @generated SignedSource<<2f3dde5eadf89c01ac337f5d59ef089d>>
 * @relayHash 5b65c404a28e6d2366150002ae80f186
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d5bdd62a8b18e81c21d0d8798c8037b784d035c46afaa88b75bdd58ae0c0307e

import type { ConcreteRequest } from 'relay-runtime';
export type useStatusUpdatesAutomationNudgeActionQuery$variables = {
  contentId: string;
};
export type useStatusUpdatesAutomationNudgeActionQuery$data = {
  readonly singleContent: {
    readonly ancestors: ReadonlyArray<{
      readonly id: string | null;
      readonly title: string | null;
    } | null> | null;
    readonly children: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly metadata: {
          readonly createdDate: string | null;
        };
        readonly title: string | null;
      } | null> | null;
    } | null;
    readonly id: string | null;
    readonly metadata: {
      readonly sourceTemplateEntityId: string | null;
    };
    readonly title: string | null;
  } | null;
};
export type useStatusUpdatesAutomationNudgeActionQuery = {
  response: useStatusUpdatesAutomationNudgeActionQuery$data;
  variables: useStatusUpdatesAutomationNudgeActionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "title"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ]
      },
      {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "sourceTemplateEntityId"
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 25
          }
        ],
        "concreteType": "PaginatedContentList",
        "kind": "LinkedField",
        "name": "children",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "createdDate"
                  }
                ]
              }
            ]
          }
        ],
        "storageKey": "children(first:25)"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useStatusUpdatesAutomationNudgeActionQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useStatusUpdatesAutomationNudgeActionQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "5b65c404a28e6d2366150002ae80f186",
    "id": "d5bdd62a8b18e81c21d0d8798c8037b784d035c46afaa88b75bdd58ae0c0307e",
    "metadata": {},
    "name": "useStatusUpdatesAutomationNudgeActionQuery",
    "operationKind": "query",
    "text": "query useStatusUpdatesAutomationNudgeActionQuery($contentId:ID!){singleContent(id:$contentId){id,title,ancestors{id,title},metadata{sourceTemplateEntityId},children(first:25){nodes{id,title,metadata{createdDate}}}}}"
  }
};
})();

(node as any).hash = "6fbe2dc2401a9bb6eab80201194f0461";

export default node;
